<template>
  <div>
    <div class="control-section dashboard-api" id="dashboard-control-section">
      <div class="content-wrapper" style="max-width:100%">
        <SPanel ref="sPanel" ></SPanel>
      </div>
    </div>
  </div>
</template>

<script>
  import SPanel from '@/components/deploymentManagement/runningEnvironment/ServerEnvironment/SPanel';

  export default {
    name: 'ServicePage',
    props: [
      'exportFlag'
    ],
    data() {
      return {

      };
    },

    components: {
      SPanel,
    },
  };
</script>
